<template>
  <a-card :bordered="false" title="会员等级" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-row style="margin-bottom: 20px;">
      <a-col :span="8">
        <a-input-search v-model="searchQueryParams.levelName" allow-clear placeholder="请输入会员等级名称"
                        :maxLength='10' style="width: 350px" @search="onSearch"/>
      </a-col>
      <a-col :span="8" :offset="8" style="text-align: right;">会员等级 <a @click="openModel">设置</a></a-col>
    </a-row>
    <custom-page-table
      ref="table"
      :columns="getColumnsList()"
      :queryParams="searchQueryParams"
      :requestPromise="loadPromise"
      :enableSearch="false"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="onEdit(rowItem.record.id)">编辑</a>
      </span>
    </custom-page-table>
    <a-modal title="会员等级设置" :width="700" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 15 }">
        <a-form-model-item label="会员等级状态" required>
          <a-switch checked-children="开" un-checked-children="关" v-model="ruleForm.status"/>
        </a-form-model-item>
        <a-form-model-item label="会员等级周期" prop="levelCycle">
          <a-select v-model="ruleForm.levelCycle" placeholder="请选择" style="width: 100%;">
            <a-select-option v-for="item in dataList" :value="item.key" :key="item.key">{{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="会员等级规则" prop="levelRuleDesc">
          <a-textarea v-model="ruleForm.levelRuleDesc" placeholder="请输入" :auto-size="{ minRows: 3, maxRows: 5 }"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 15,offset: 5 }" style="margin-bottom: 0;">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
          <a-button @click="handleCancel" style="margin-left: 10px;">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'MemberAscendList',
  mixins: [],
  components: {},
  data() {
    return {
      searchQueryParams: {
        levelName: '',
        merchantId: this.$store.getters.userInfo.merchantId
      },
      loadPromise: params => this.getListPromise(params),
      visible: false,
      ruleForm: {
        id: '',// 会员等级设置ID ,
        levelCycle: '',// 会员等级周期 1=注册之日起365天为一个周期 ,
        levelRuleDesc: '',// 会员等级规则 ,
        status: false// 会员等级状态 0=未开启（默认）、1=开启
      },
      rules: {
        levelCycle: [{ required: true, message: '请选择会员等级周期', trigger: 'change' }]
      },
      submitLoading: false,
      dataList: []
    }
  },
  mounted() {
    this.getMemberLevelCycleEnum()
  },
  methods: {
    onSearch() {
      this.$refs.table.refresh(true)
    },
    onEdit(id) {
      this.openNewPage('EditMemberAscend', { id })
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getIntegralApiService().post('admin/memberLevel/listPage', params)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      params.status = params.status ? 1 : 0// 会员等级状态 0=未开启（默认）、1=开启
      this.getLogUtils().logWithTag('params', params)
      this.getHttpServices().getIntegralApiService().post('admin/memberLevel/setting/update', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.visible = false
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    openModel() {
      this.getMemberDetail()
    },
    getMemberDetail() {
      this.getHttpServices().getIntegralApiService().post('admin/memberLevel/setting/detail').then(res => {
        this.getLogUtils().logWithTag('详情', res)
        if (res && res.id) {
          this.visible = true
          this.ruleForm = { ...res }
          this.ruleForm.status = res.status == 1 ? true : false
        } else {
          this.resetRuleForm()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    resetRuleForm() {
      this.ruleForm = {
        id: '',// 会员等级设置ID ,
        levelCycle: '',// 会员等级周期 1=注册之日起365天为一个周期 ,
        levelRuleDesc: '',// 会员等级规则 ,
        merchantId: this.$store.getters.userInfo.merchantId,// 商户ID ,
        status: false// 会员等级状态 0=未开启（默认）、1=开启
      }
    },
    getMemberLevelCycleEnum() {
      this.getHttpServices().getIntegralApiService().post('admin/memberLevel/getMemberLevelCycleEnum').then(res => {
        this.getLogUtils().logWithTag('枚举', res)
        this.dataList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleCancel() {
      this.visible = false
    },
    getColumnsList() {
      return [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '会员等级名称',
          dataIndex: 'levelName'
        },
        {
          title: '会员数量',
          dataIndex: 'memberNum'
        },
        {
          title: '等级级别',
          dataIndex: 'levelStr'
        },
        {
          title: '升级门槛',
          dataIndex: 'upgradePoint',
          width: '25%'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}
</style>
